"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChartPieSolid: function() {
        return ChartPieSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ChartPieSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11 1.04485C5.3935 1.55007 1 6.26196 1 12C1 14.6775 1.95662 17.1316 3.54673 19.0391L11 11.5858V1.04485Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M4.96094 20.4533C6.86844 22.0434 9.3225 23 12 23C17.738 23 22.4499 18.6065 22.9552 13H12.4142L4.96094 20.4533Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M22.9552 11C22.4796 5.72286 18.2771 1.52039 13 1.04485V11H22.9552Z",
            fill: "currentColor"
        })
    ]
}), "ChartPieSolid");
const _default = ChartPieSolid;
